import axios, { AxiosResponse } from 'axios';
import {logsApi} from 'constants/api';
import {Log, LogsListCsvProps, LogsListProps} from './types';

export class LogsService {
    getList = async (params: LogsListProps): Promise<AxiosResponse<Log[]>> => (
        axios.get(logsApi, { params })
    );

    getReportInCsv = async (params: LogsListCsvProps): Promise<AxiosResponse> => (
        axios.get(`${logsApi}/csv`, { params, responseType: 'blob' })
    );
}